// extracted by mini-css-extract-plugin
export var container = "_kr-0";
export var outlet = "_kr-1";
export var outletEnter = "_kr-2";
export var outletEnterActive = "_kr-3";
export var outletExit = "_kr-4";
export var outletExitActive = "_kr-5";